import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useAuth } from './Context/AuthContext';
import apiClient from './Api/axiosConfig';
import trackEvent from './services/AnalyticsService';

import Navbar from "./Components/Navbar"
import Footer from './Components/Footer';
import Home from "./Pages/Home";
import About from './Pages/About';
import Books from './Pages/Books';
import BookDetail from './Pages/BookDetail';
import Contact from './Pages/Contact';

import ProtectedRoute from './Components/ProtectedRoute';
import AdminLogin from './Pages/Admin/AdminLogin';
import AdminLogout from './Pages/Admin/AdminLogout';
import AdminLayout from './Pages/Admin/AdminLayout';
import DashboardPage from './Pages/Admin/pages/DashboardPage';
import GlobalSettingsPage from './Pages/Admin/pages/GlobalSettingsPage';
import AuthorPage from './Pages/Admin/pages/AuthorPage';
import BooksPage from './Pages/Admin/pages/BooksPage';
import FeedbacksPage from './Pages/Admin/pages/FeedbacksPage';
import PraisesPage from './Pages/Admin/pages/PraisesPage';
import AnalyticsPage from './Pages/Admin/pages/AnalyticsPage';
import SocialPage from './Pages/Admin/pages/SocialPage';

function AppContent(){
  const location = useLocation();
  const { setIsLoggedIn } = useAuth();

  const [siteData, setSiteData] = useState(null);
  const [siteMeta, setSiteMeta] = useState(null);
  
  const fetchData = useCallback(() => { apiClient.get('/data').then(response => { let data = response.data; setSiteData(data); setSiteMeta(data.siteMeta); }); },[]);

  useEffect(() => { fetchData(); },[fetchData]);
  useEffect(() => { apiClient.get('/auth/checkAuth') .then(() => { setIsLoggedIn(true); }) .catch(() => { setIsLoggedIn(false); }); },[setIsLoggedIn]);
  useEffect(() => { 
    if(location.pathname == '/'){
      trackEvent('page_view', { path: location.pathname }); 
    };
  }, [location.pathname]);

  if(!siteData){ return <div>Adatok betöltése...</div> };

  const featuredBook = siteData.books.find(book => book.isFeatured) || siteData.books[0];

  if (!siteData) { return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>Adatok betöltése...</div>; }
  return (
    <>
      {siteMeta && (
        <>
          <title>{siteMeta.title}</title>
          <link rel="canonical" href="https://www.tacobell.com/" />
          <meta name="description" content={siteMeta.description} />
          <meta property="og:title" content={siteMeta.ogTitle} />
          <meta property="og:description" content={siteMeta.ogDescription} />
          <meta property="og:image" content={`${window.location.origin}${siteMeta.ogImage}`} />
          <meta property="og:type" content="website" />
          <link rel="icon" href={siteMeta.favicon} />
        </>
      )}
      <Navbar author={siteData.author}/>
        <main>
          <Routes>
            <Route path="/" element={<Home praises={siteData.praises || []} featuredBook={featuredBook} authorName={siteData.author.name} />} />
            <Route path="/rolam" element={<About author={siteData.author}/>} />
            <Route path="/konyveim" element={<Books books={siteData.books}/>} />
            <Route path="/konyv/:bookId" element={<BookDetail books={siteData.books} feedbacks={siteData.feedbacks} onFeedbackSubmit={fetchData}/>} />
            <Route path="/kapcsolat" element={<Contact />} />

            {/* Admin útvonalak */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<DashboardPage />} />
              <Route path="global" element={<GlobalSettingsPage />} />
              <Route path="praises" element={<PraisesPage />} />
              <Route path="author" element={<AuthorPage />} />
              <Route path="books" element={<BooksPage />} />
              <Route path="feedbacks" element={<FeedbacksPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="social" element={<SocialPage />} />
            </Route>
            <Route path="/admin/logout" element={<AdminLogout />} />
            {/* Admin útvonalak vége*/}
          </Routes>
        </main>        
        <Footer siteMeta={siteMeta}/>
    </>
  );
}

function App(){
  return (
    <>
      <Router>
        <AppContent />
      </Router>
    </>
  )
};

export default App;